import palette from "../palette";

export default {
	root: {
		"&.Mui-checked .MuiIconButton-label > div > svg:nth-of-type(1)": {
			color: palette.highlight,
		},
	},
};
